import {apiHelper,PromiseHandler} from "../redux/apiHelper"
const getEmailTemplates=()=>PromiseHandler(apiHelper('get',`/api/admin/email-template/get`))
const deleteEmailTemplateById=(id)=>PromiseHandler(apiHelper('post',`/api/admin/email-template/delete/${id}`))
const getEmailTemplateById=(id)=>PromiseHandler(apiHelper('get',`/api/admin/email-template/get/${id}`))
const addEmailTemplate=(data)=>PromiseHandler(apiHelper('post','/api/admin/email-template/create',data))
const updateEmailTemplateById=(id,data)=>PromiseHandler(apiHelper('post',`/api/admin/email-template/update/${id}`,data))
export {getEmailTemplates,deleteEmailTemplateById,addEmailTemplate,updateEmailTemplateById,getEmailTemplateById}
